class Cart {
  constructor() {
    this.cartData = null
    this.cartElement = document.querySelector('#side-cart')
    this.closeButton = document.querySelector('.side-cart-close')
    this.removeItemButtons = document.querySelectorAll('.cart-item-remove')
    this.updateItemQuantityButtons = document.querySelectorAll('.cart-item-quantity_button')
    this.addSuggestedToCartButtons = document.querySelectorAll('.suggestion-add-to-cart')
    this.initiate()
  }

  initiate() {
    this.mountSplide()

    document.addEventListener('toggleCart', () => {
      this.toggleCart()
    })
    document.addEventListener('updateCart', () => {
      this.updateCart()
    })
    this.closeButton.addEventListener('click', () => {
      this.toggleCart()
    })
    this.removeItemButtons.forEach(button => {
      button.addEventListener('click', () => this.removeItem(button))
    })
    this.updateItemQuantityButtons.forEach(button => {
      button.addEventListener('click', () => this.handleCartQuantityChange(button))
    })
    this.addSuggestedToCartButtons.forEach(button => {
      button.addEventListener('click', () => this.handleAddSuggestedToCart(button))
    })
  } 

  // This method updated the event listeners for elements that get re-rendered
  update() {
    this.closeButton.addEventListener('click', () => {
      this.toggleCart()
    })
    this.removeItemButtons.forEach(button => {
      button.addEventListener('click', () => this.removeItem(button))
    })
    this.updateItemQuantityButtons.forEach(button => {
      button.addEventListener('click', () => this.handleCartQuantityChange(button))
    })
    this.addSuggestedToCartButtons.forEach(button => {
      button.addEventListener('click', () => this.handleAddSuggestedToCart(button))
    })
    this.mountSplide()
  }

  async fetchCartData() {
    const response = await fetch('/cart.js')
    this.cartData = await response.json()
    // console.log(this.cartData)
  }
  
  toggleCart() {
    this.cartElement.classList.toggle('active')
  }

  mountSplide() {
    const splideEl = document.querySelector('#cart_suggestions')
    if (!splideEl) return

    new Splide(`#cart_suggestions`, {
      type: 'loop',
      perPage: 2,
      perMove: 1,
      gap: '1rem',
      pagination: false,
      arrows: false,
    }).mount();
  }

  // Updates cart UI with the latest cart data
  // The HTML elements need to be re-assigned to the Class (this)
  async updateCart() {
    const res = await fetch(window.Shopify.routes.root + '?sections=main-side-cart')
    const data = await res.json()
    const parser = new DOMParser()
    const doc = parser.parseFromString(data['main-side-cart'], 'text/html')

    const updatedHeaderSection = doc.querySelector('.side-cart-header')
    const headerSection = document.querySelector('.side-cart-header')

    const updatedCloseButton = updatedHeaderSection.querySelector('.side-cart-close')
    this.closeButton = updatedCloseButton

    headerSection.replaceWith(updatedHeaderSection)

    const updatedContentSection = doc.querySelector('.side-cart-content')
    const contentSection = document.querySelector('.side-cart-content')

    const updatedItemQuantityButtons = updatedContentSection.querySelectorAll('.cart-item-quantity_button')
    this.updateItemQuantityButtons = updatedItemQuantityButtons

    const updatedRemoveItemButtons = updatedContentSection.querySelectorAll('.cart-item-remove')
    this.removeItemButtons = updatedRemoveItemButtons

    const updatedAddSuggestedToCartButtons = updatedContentSection.querySelectorAll('.suggestion-add-to-cart')
    this.addSuggestedToCartButtons = updatedAddSuggestedToCartButtons

    contentSection.replaceWith(updatedContentSection)

    this.update()
  }

  async updateItemQuantity(lineItem, quantity) {
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'line': lineItem,
        'quantity': quantity
      })
    })
  }

  async removeItem(button) {
    const index = button.dataset.itemIndex
    await this.updateItemQuantity(index, 0)
    this.updateCart()
  }

  async handleCartQuantityChange(button) {
    const { action, itemIndex, itemCurrentQty } = button.dataset
    await this.updateItemQuantity(itemIndex, action === 'increase' ? parseInt(itemCurrentQty) + 1 : parseInt(itemCurrentQty) - 1)
    this.updateCart()
  }

  async addToCart(items) {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    })

    if (res.status === 422) {
      toast('Ce produit est en rupture de stock')
    }
  }

  async handleAddSuggestedToCart(button) {
    button.classList.add('loading')
    const parentElement = button.closest('.cart-product-suggestion-content')
    let productVariants = Array.from(parentElement.querySelectorAll('.cart-product-variants option'))
    productVariants = productVariants.map(variant => ({
      title: variant.dataset.variantTitle,
      id: variant.value,
    }))
    let selectedOptions = Array.from(parentElement.querySelectorAll('.cart-product-option'))
    selectedOptions = selectedOptions.map(option => option.value)
    
    const selectedVariant = productVariants.find(variant => variant.title === selectedOptions.join(' / '))
    if (selectedVariant) {
      await this.addToCart([{ id: selectedVariant.id, quantity: 1}])
      this.updateCart()
    }
    button.classList.remove('loading')
  }

}

document.addEventListener("DOMContentLoaded", () => {
  new Cart()
})
